var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "hiddenScrollbar detail" }, [
    _c(
      "div",
      { staticClass: "Site-Info box" },
      [
        _c("w-image", {
          ref: "wImage",
          attrs: {
            pictures: _vm.community.pictures,
            name: "外观",
            state: _vm.community.state,
            brandName: _vm.community.otherResourceData
              ? _vm.community.otherResourceData.brandName
              : "",
          },
          nativeOn: {
            click: function ($event) {
              return _vm.showImages.apply(null, arguments)
            },
          },
        }),
        _c("div", { staticClass: "Right" }, [
          _c("div", { staticClass: "Right-Top" }, [
            _c("div", { staticClass: "Right-One Right-Padding" }, [
              _vm.community.score
                ? _c("span", [
                    _vm._v(_vm._s(_vm.community.score)),
                    _c("span", { staticStyle: { "font-size": "15px" } }, [
                      _vm._v("分"),
                    ]),
                  ])
                : _c("span", { staticStyle: { "font-size": "14px" } }, [
                    _vm._v("暂无评分"),
                  ]),
            ]),
            _c("div", { staticClass: "Right-One-Site Right-Padding" }, [
              _c("p", [
                _vm._v(
                  "会场类型：" + _vm._s(_vm.community.thirdData.site_type)
                ),
              ]),
              _c("p", [
                _vm._v("会场数量：" + _vm._s(_vm.community.thirdData.site_num)),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "Right-Two Right-Padding" },
              [
                _vm.community.star
                  ? _c("el-rate", {
                      attrs: { max: _vm.community.star, disabled: "" },
                      model: {
                        value: _vm.community.star,
                        callback: function ($$v) {
                          _vm.$set(_vm.community, "star", $$v)
                        },
                        expression: "community.star",
                      },
                    })
                  : _vm._e(),
                _vm.community.addressCn
                  ? _c("i", {
                      staticClass: "el-icon-location-outline van-icon",
                    })
                  : _vm._e(),
                _c("span", { staticClass: "ellipsis" }, [
                  _vm._v(_vm._s(_vm.community.addressCn)),
                ]),
              ],
              1
            ),
          ]),
        ]),
      ],
      1
    ),
    _vm.community.introduction
      ? _c("div", { staticClass: "Introduce box box-kuang" }, [
          _c(
            "p",
            { staticStyle: { display: "flex" } },
            [
              _c("svg-icon", {
                staticClass: "icon-title",
                attrs: { iconClass: "jianjie" },
              }),
              _vm._v("简介"),
            ],
            1
          ),
          _c(
            "p",
            { staticClass: "box-content", staticStyle: { color: "#323232" } },
            [_vm._v(_vm._s(_vm.community.introduction))]
          ),
        ])
      : _vm._e(),
    _vm.community.thirdData.time_info_list
      ? _c("div", { staticClass: "Introduce box box-kuang" }, [
          _c(
            "p",
            { staticStyle: { display: "flex" } },
            [
              _c("svg-icon", {
                staticClass: "icon-title",
                attrs: { iconClass: "businessHours" },
              }),
              _vm._v("营业时间"),
            ],
            1
          ),
          _c(
            "p",
            { staticClass: "box-content", staticStyle: { color: "#323232" } },
            [_vm._v(_vm._s(_vm.community.thirdData.time_info_list.join("、")))]
          ),
        ])
      : _vm._e(),
    _vm.community.thirdData.pdf_downloads_info.length > 0
      ? _c(
          "div",
          { staticClass: "Service box box-kuang" },
          [
            _c(
              "p",
              { staticStyle: { display: "flex" } },
              [
                _c("svg-icon", {
                  staticClass: "icon-title",
                  attrs: { iconClass: "relatedData" },
                }),
                _vm._v("相关资料"),
              ],
              1
            ),
            _vm._l(
              _vm.community.thirdData.pdf_downloads_info,
              function (item, index) {
                return _c(
                  "a",
                  {
                    key: index,
                    staticClass: "box-content",
                    staticStyle: {
                      color: "#323232",
                      cursor: "pointer",
                      "text-decoration": "underline",
                    },
                    attrs: { target: "_blank", href: item },
                  },
                  [_vm._v(_vm._s(item.split("/").pop()))]
                )
              }
            ),
          ],
          2
        )
      : _vm._e(),
    _vm.community.thirdData.site_room_list &&
    _vm.community.thirdData.site_room_list.length > 0
      ? _c(
          "div",
          {
            staticClass: "Service box box-kuang",
            staticStyle: { width: "6rem" },
          },
          [
            _c(
              "p",
              { staticStyle: { display: "flex" } },
              [
                _c("svg-icon", {
                  staticClass: "icon-title",
                  attrs: { iconClass: "relatedData" },
                }),
                _vm._v("会场资料"),
              ],
              1
            ),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.community.thirdData.site_room_list,
                  border: "",
                  "max-height": "250",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    fixed: "",
                    align: "center",
                    prop: "site_name",
                    width: "100",
                    label: "会场名称",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "name",
                    width: "60",
                    label: "高(m)",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "site_height",
                    width: "60",
                    label: "长(m)",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "site_width",
                    width: "60",
                    label: "宽(m)",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "site_area",
                    width: "80",
                    label: "面积(m²)",
                  },
                }),
                _vm._l(_vm.siteImg, function (item, index) {
                  return _c("el-table-column", {
                    key: index,
                    attrs: { align: "center", width: "60" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function (scope) {
                            return [
                              _c("img", {
                                staticClass: "imgs",
                                attrs: { src: item.url, alt: "" },
                              }),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(scope.row[item.key].people_number) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  })
                }),
              ],
              2
            ),
          ],
          1
        )
      : _vm._e(),
    _vm.community.thirdData.mp4.length > 0
      ? _c(
          "div",
          { staticClass: "Service box box-kuang" },
          [
            _c(
              "p",
              { staticStyle: { display: "flex" } },
              [
                _c("svg-icon", {
                  staticClass: "icon-title",
                  attrs: { iconClass: "video" },
                }),
                _vm._v("相关视频"),
              ],
              1
            ),
            _vm._l(_vm.community.thirdData.mp4, function (url, index) {
              return _c(
                "a",
                {
                  key: index,
                  staticClass: "box-content",
                  staticStyle: {
                    color: "#323232",
                    cursor: "pointer",
                    "text-decoration": "underline",
                  },
                  attrs: { target: "_blank", href: url },
                },
                [_vm._v(_vm._s(url.split("/").pop()))]
              )
            }),
          ],
          2
        )
      : _vm._e(),
    _vm.community.thirdData.sb_info_list
      ? _c("div", { staticClass: "Service box box-kuang" }, [
          _c(
            "p",
            { staticStyle: { display: "flex" } },
            [
              _c("svg-icon", {
                staticClass: "icon-title",
                attrs: { iconClass: "siteSheshi" },
              }),
              _vm._v("会议设施"),
            ],
            1
          ),
          _c(
            "p",
            { staticClass: "box-content", staticStyle: { color: "#323232" } },
            [_vm._v(_vm._s(_vm.community.thirdData.sb_info_list.join("、")))]
          ),
        ])
      : _vm._e(),
    _vm.community.thirdData.ts_info_list
      ? _c("div", { staticClass: "Service box box-kuang" }, [
          _c(
            "p",
            { staticStyle: { display: "flex" } },
            [
              _c("svg-icon", {
                staticClass: "icon-title",
                attrs: { iconClass: "equipment" },
              }),
              _vm._v("特殊设备"),
            ],
            1
          ),
          _c(
            "p",
            { staticClass: "box-content", staticStyle: { color: "#323232" } },
            [_vm._v(_vm._s(_vm.community.thirdData.ts_info_list.join("、")))]
          ),
        ])
      : _vm._e(),
    _c("div", { staticClass: "Traffic box box-kuang" }, [
      _c(
        "p",
        { staticStyle: { display: "flex" } },
        [
          _c("svg-icon", {
            staticClass: "icon-title",
            attrs: { iconClass: "guanwang" },
          }),
          _vm._v("官网及联系电话"),
        ],
        1
      ),
      _vm.community.website
        ? _c(
            "p",
            { staticClass: "box-content", staticStyle: { color: "#323232" } },
            [_vm._v("web：" + _vm._s(_vm.community.website))]
          )
        : _vm._e(),
      _vm.community.phone
        ? _c(
            "p",
            { staticClass: "box-content", staticStyle: { color: "#323232" } },
            [_vm._v("phone：" + _vm._s(_vm.community.phone))]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }